module.exports = __webpack_public_path__ + "img/avatar.5305d38b.png";